<script setup lang="ts">
const { t } = useI18n()

const props = withDefaults(
  defineProps<{
    disclaimer?: string
    errors?: {
      [key: string]: string
    }
    maximumCharacters?: string
    min?: number
    modelValue: string | number | null
    required?: boolean
    step?: string
    title: string
    type?: string
  }>(),
  {
    errors: () => ({}),
    maximumCharacters: null,
    required: false,
    step: null,
    type: 'text'
  }
)

const emit = defineEmits<{
  (event: 'update:modelValue', value: string | number): void
  (event: 'update:errors', value: { [key: string]: string | null }): void
}>()

const handleInput = (value: string | number) => {
  emit('update:modelValue', value)
  emit('update:errors', {
    ...props.errors,
    [props.title]: null
  })
}
</script>

<template>
  <div>
    <label for="name" class="mb-1 flex items-center gap-1 text-sm font-medium text-foreground">
      <span>{{ t(`pages.loyaltyPage.edit.fields.${title}`) }}</span>
      <span v-if="required" class="text-red-500">*</span>
    </label>
    <AppFormInput
      :id="title"
      :model-value="modelValue"
      :name="title"
      :type="type"
      :step="step"
      :maxlength="maximumCharacters"
      :min="min"
      :errors="errors[title] ? [errors[title]] : []"
      @update:model-value="handleInput"
    >
      <template #subtext>
        <slot name="subtext" />
      </template>
    </AppFormInput>
    <div v-if="disclaimer" class="mt-1 text-sm text-muted-foreground">{{ disclaimer }}</div>
  </div>
</template>
